import Dashboard from './dashboard';

export default {
    path: '/dashboard',
    component: Dashboard,
}